// Memory storage used by apollo client to set x-admin-account-id-for-pricing header
// for Internal Admin users. Header used in backend to resolve Cost Plus pricing.
let currentAccountIdForPricing: string | undefined

export const setAccountIdForPricing = (value: string | undefined) => {
  currentAccountIdForPricing = value
}

export const getAccountIdForPricing = (): string | undefined => {
  return currentAccountIdForPricing
}

export const clearAccountIdForPricing = () => {
  currentAccountIdForPricing = undefined
}
